import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const detection = {
  // order and from where user language should be detected
  order: ['querystring', 'localStorage', 'navigator'],

  lookupQuerystring: 'lng',
  lookupLocalStorage: 'airthings.i18nextLng',

  // cache user language on
  caches: ['localStorage'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
};

i18next
  // Load translations from public/locales
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: ` ${process.env.PUBLIC_URL}/locales/{{lng}}.json`,
    },
    debug: process.env.NODE_ENV !== 'development',
    detection,
    fallbackLng: {
      default: ['en'],
    },
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['en'],
  });

export default i18next;
